<template>
  <div class="worksetuptable">
    <el-table :data="tableData"
              style="width: 100%; padding: 10px 10px 0 10px"
              
              border>
      <el-table-column prop="name"
                       width="250"
                       label="工作圈名称"></el-table-column>
      <el-table-column prop="createUserInfo.name"
                       width="150"
                       label="创建人"></el-table-column>
      <el-table-column prop="accessCount"
                       width="150"
                       label="关联用户">
        <template slot-scope="scope">
          <span>{{scope.row.accessCount}} 位</span>
        </template>
      </el-table-column>
      <el-table-column prop="desc"
                       label="简介"></el-table-column>

      <el-table-column label="操作"
                       width="300">
        <template slot-scope="scope">
          <el-button @click="relationClick(scope)"
                     style="color: #f96900; font-weight: bold; font-size: 13px"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right: 3px"
               class="el-icon-document-checked"></i>关联用户</el-button>
          <span style="margin: 0 11px">|</span>

          <el-button @click="changeClick(scope)"
                     style="color: #185ed3; font-weight: bold; font-size: 13px"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right: 3px"
               class="el-icon-edit-outline"></i>修改</el-button>
          <span style="margin: 0 11px">|</span>
          <el-button @click="removeClick(scope)"
                     style="color: #FF4545; font-weight: bold; font-size: 13px"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right: 3px"
               class="el-icon-delete"></i>删除</el-button>

        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "worksetuptable",
  props: {
    tableData: Array,
  },
  data () {
    return {};
  },
  methods: {
    changeClick (scope) {
      this.$emit("changeClick", scope);
    },
    removeClick (scope) {
      this.$emit("removeClick", scope);
    },
    relationClick (scope) {
      this.$emit("relationClick", scope);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table {
  width: auto;
}
.active {
  color: red;
}
.btn:hover {
  text-decoration: underline;
}
</style>
